import { render } from "./BaseInputCore.vue?vue&type=template&id=2af31545&scoped=true"
import script from "./BaseInputCore.vue?vue&type=script&lang=js"
export * from "./BaseInputCore.vue?vue&type=script&lang=js"

import "./BaseInputCore.vue?vue&type=style&index=0&id=2af31545&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af31545"]])

export default __exports__